import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { customTheme } from "../../../../../../config/theme/MuiTheme";
import TransferReasonService from "../../TransferReasonService";
import { useContext } from "react";
import { ContextOperation } from "../../../../context/OperationContext";
import useSnackbar from "../../../../hooks/useSnackbar";
import useOperationTranslation from "../../../../hooks/useOperationTranslation";
import { TransferReasonTypes } from "../../Types";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";

interface Props {
    open: boolean;
    onClose: () => void;
    onMessageSent: () => void;
    requestId?: number;
    carrier?: TransferReasonTypes.ICarrierTender;
    transferRequestNumber?: string;
}

const SendMessage = (props: Props) => {
    const { tenant } = useContext(ContextOperation);

    const snackbar = useSnackbar();
    
    const t = useOperationTranslation();
    
    const onSendMessage = () => {
        if (!props.requestId || !props.carrier?.supplierBpCode || !props.transferRequestNumber) {
            snackbar.show("warning", t("transferReason.manageCarriers.warningSnackBar"));
            return;
        }

        // if (!props.carrier.email) {
        //     snackbar.show("warning", t("transferReason.manageCarriers.warningNoEmail"));
        //     return;
        // }

        dayjs.extend(timezone);

        const data: TransferReasonTypes.ISendInvitation = {
            type: props.carrier.type,
            approvalDate: dayjs(new Date()).tz("Europe/Rome").format("DD-MM-YYYY HH:mm:ss Z"),
            basePrice: props.carrier.basePrice,
            email: props.carrier.email,
            finalPrice: props.carrier.finalPrice,
            loadIndex: props.carrier.loadIndex,
            transferRequestNumber: props.transferRequestNumber,
            transportatorAddress: props.carrier.carrierAddress,
            transportatorCity: props.carrier.carrierCity,
            transportatorName: props.carrier.carrierName,
            validityEndDate: dayjs(props.carrier.endValidity).tz("Europe/Rome").format("DD-MM-YYYY HH:mm:ss Z"),
            validityStartDate: dayjs(props.carrier.startValidity).tz("Europe/Rome").format("DD-MM-YYYY HH:mm:ss Z"),
            variationPrice: props.carrier.variation
        }

        TransferReasonService.put.sendInvitation(tenant, props.requestId, props.carrier.supplierBpCode, data).then(
            () => {
                props.onClose();
                props.onMessageSent();
                snackbar.show("success", t("transferReason.manageCarriers.requestSnackBar"));
            },
            () => {
                snackbar.show("error", t("transferReason.manageCarriers.errorSnackBar"));
            }
        )
    }

    return(
        <>
            <Mui.Dialog open={props.open} onClose={props.onClose} fullWidth={true} maxWidth="sm">
                <Mui.DialogTitle>
                    <Mui.Grid container alignItems="center">
                        <Mui.Grid item xs="auto">
                            <Mui.Grid container spacing={1}>
                                <Mui.Grid item xs="auto" color={customTheme.palette.accent.main}>
                                    <MuiIcons.Info color="inherit" />
                                </Mui.Grid>
                                
                                <Mui.Grid item xs="auto">
                                    <Mui.Typography>
                                        {t("transferReason.manageCarriers.approveConfirmation")}
                                    </Mui.Typography>
                                </Mui.Grid>
                            </Mui.Grid>
                        </Mui.Grid>

                        <Mui.Grid item xs="auto" marginLeft="auto">
                            <Mui.IconButton onClick={props.onClose}>
                                <MuiIcons.Close />
                            </Mui.IconButton>
                        </Mui.Grid>
                    </Mui.Grid>
                </Mui.DialogTitle>

                <Mui.DialogContent>
                    <Mui.Typography>
                        {t("transferReason.manageCarriers.messagePopup").replace("#textElement", props.carrier?.carrierName || "")}
                    </Mui.Typography>
                    
                    {!props.carrier?.email && (
                        <Mui.Typography>
                            <br/>
                            {t("transferReason.manageCarriers.warningNoEmail")}
                        </Mui.Typography>
                    )}
				</Mui.DialogContent>

                <Mui.DialogActions>
                    <Mui.Grid item>
                        <Mui.Button variant="outlined" size="smallPlus" onClick={props.onClose}>
                            {t("transferReason.manageCarriers.cancelButton")}
                        </Mui.Button>
                    </Mui.Grid>
                    <Mui.Grid item>
                        <Mui.Button size="smallPlus" onClick={onSendMessage}>
                            {t("transferReason.manageCarriers.okButton")}
                        </Mui.Button>
                    </Mui.Grid>
                </Mui.DialogActions>
            </Mui.Dialog>
        </>
    )
}
export default SendMessage;